import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './core/filters/index.js'
import ElementUI from 'element-ui';
import './common/styles/element-variables.scss'
import { DatePicker } from "ant-design-vue";
import 'ant-design-vue/lib/date-picker/style/css';
import JsonViewer from 'vue-json-viewer'

Vue.use(ElementUI, { size: 'small' })

Vue.use(DatePicker)

Vue.use(JsonViewer)

Vue.config.productionTip = false

// 全局过滤器
Object.keys(filters).forEach(filterName => {
    Vue.filter(filterName, filters[filterName])
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
